module.exports = __webpack_public_path__ + "img/IconWarning.b6ccdaee.svg";